define("auth/components/login-form", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency-decorators", "ember-concurrency-ts"], function (_exports, _component, _templateFactory, _service, _component2, _tracking, _emberConcurrencyDecorators, _emberConcurrencyTs) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _clearPassword;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{!-- Login Page --}}
  <div class="tSU--container" data-test-id="login-form-template">
    {{!-- Cards --}}
    <div class="tSU--container__row">
      {{!-- Card --}}
      <div class="tSU--card">
        <h1 class="tSU--card__title">{{t "authorization.sign_in_form.title"}}</h1>
        {{!-- Form Objects --}}
        <form
          class="u--p__t__lg"
          {{on "submit" (perform this.login this.identification this.password this.twoFactorCode)}}
        >
          <div class="o--formWrapper--lg">
            <label>{{t "shared_words.email"}} </label>
            <Input
              @value={{this.identification}}
              @type="email"
              @placeholder={{t "authorization.sign_in_form.email_placeholder"}}
              @autocomplete="username"
              @class="form-control o--form__input qa--signin_email_input"
              @disabled={{this.twoFactorEnabled}}
              {{autofocus}}
            />
          </div>
          {{!-- Password --}}
          <Shared::Credentials::PasswordInput 
            @dataTestID="login-password-input" 
            @qaClassName="signin_password_input"
            @password={{this.password}}/>
  
          {{#if this.twoFactorEnabled}}
            <div class="o--formWrapper--lg">
              <label>{{t "authorization.sign_in_form.2fa_input_label"}}</label>
              <Input
                @value={{this.twoFactorCode}}
                @placeholder={{t "authorization.sign_in_form.2fa_input_placeholder"}}
                @type="text"
                @class="form-control o--form__input"
                {{autofocus}}
              />
            </div>
          {{/if}}
  
          <div class="o--formSubmit">
            <Shared::Ui::Button
              type="submit"
              class="qa--login__btn"
              @size="large"
              @additional="block"
              @text={{t "authorization.sign_in"}}
              @isDisabled={{this.isLoginDisabled}}
              data-test-id="login-form-submit-button"
            />
          </div>
        </form>
  
        <p class="u--text--center u--m__b__lg u--m__t">
          {{if @isSsoLogin (t "authorization.new_to_later_sso_long" ssoAppName=@ssoAppName) (t "authorization.new_to_later")}}
          <LinkTo @route="signup" class="u--p__l__xs">
            {{html-safe (t "authorization.create_an_account")}}
          </LinkTo>
        </p>
  
        {{!-- Forgot Password --}}
        <div class="u--row u--p__t__lg">
          <LinkTo
            @route="reset_password"
            class="u--text--light u--text--underline u--text--sm u--block u--block u--col__6"
          >
            {{t "authorization.sign_in_form.forgot_password"}}
          </LinkTo>
          <a
            class="u--text--light u--text--underline u--text--sm u--block u--col__6"
            {{on "click" (toggle-action "showIgHelp" this)}}
          >
            {{t "authorization.sign_in_form.sign_in_ig"}}
          </a>
          {{#if this.showIgHelp}}
            <div class="u--col__12 u--fadeIn u--clearfix">
              <p class="u--p__t__xs u--m__b u--text--sm">{{t "authorization.sign_in_form.sign_in_ig_answer"}}</p>
              <LinkTo
                @route="forgot_email"
                class="u--text--light u--text--underline u--text--sm u--block u--m__t__xs"
              >
                {{t "authorization.forgot_email"}}
              </LinkTo>
            </div>
          {{/if}}
        </div>
      </div>
  
      {{!-- Feature Card --}}
      <div class="tSU--card tSU--card--featured">
        <p class="tSU--card__title--featured">{{html-safe (t "authorization.sign_in_banner.title")}}</p>
        {{!-- <p class="u--text--light u--p__t__0">
          <Shared::Link @href="https://later.com/linkinbio/">
            {{t "shared_phrases.learn_more"}}
          </Shared::Link>
        </p> --}}
  
        {{!-- <Shared::Link @href="https://www.later.com/training">
          <img
            src="/assets/images/img--signIn--featured--fg.png"
            class="tSU--card__image"
          >
        </Shared::Link> --}}
      </div>
    </div>
  </div>
  
  {{!-- Successful / Get started --}}
  <div class="tSU--container u--hide">
    {{!-- Card --}}
    <div class="tSU--card">
      <h1 class="tSU--card__title">{{t "authorization.get_started.title"}}</h1>
      <p class="u--text--md u--m__b__lg">{{t "authorization.get_started.sub_title"}}</p>
      <Shared::Ui::Button
        class="u--m__b u--m__t__lg"
        @size="large"
        @additional="block"
        @text={{t "authorization.get_started.calendar"}}
      />
      <Shared::Ui::Button
        @size="large"
        @type="outline"
        @additional="block"
        @text={{t "authorization.get_started.rewards"}}
      />
    </div>
  </div>
  
  */
  {
    "id": "cxWHMnVK",
    "block": "[[[10,0],[14,0,\"tSU--container\"],[14,\"data-test-id\",\"login-form-template\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tSU--container__row\"],[12],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"tSU--card\"],[12],[1,\"\\n      \"],[10,\"h1\"],[14,0,\"tSU--card__title\"],[12],[1,[28,[35,0],[\"authorization.sign_in_form.title\"],null]],[13],[1,\"\\n\"],[1,\"      \"],[11,\"form\"],[24,0,\"u--p__t__lg\"],[4,[38,1],[\"submit\",[28,[37,2],[[30,0,[\"login\"]],[30,0,[\"identification\"]],[30,0,[\"password\"]],[30,0,[\"twoFactorCode\"]]],null]],null],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--formWrapper--lg\"],[12],[1,\"\\n          \"],[10,\"label\"],[12],[1,[28,[35,0],[\"shared_words.email\"],null]],[1,\" \"],[13],[1,\"\\n          \"],[8,[39,3],[[4,[38,4],null,null]],[[\"@value\",\"@type\",\"@placeholder\",\"@autocomplete\",\"@class\",\"@disabled\"],[[30,0,[\"identification\"]],\"email\",[28,[37,0],[\"authorization.sign_in_form.email_placeholder\"],null],\"username\",\"form-control o--form__input qa--signin_email_input\",[30,0,[\"twoFactorEnabled\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[8,[39,5],null,[[\"@dataTestID\",\"@qaClassName\",\"@password\"],[\"login-password-input\",\"signin_password_input\",[30,0,[\"password\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"twoFactorEnabled\"]],[[[1,\"          \"],[10,0],[14,0,\"o--formWrapper--lg\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,[28,[35,0],[\"authorization.sign_in_form.2fa_input_label\"],null]],[13],[1,\"\\n            \"],[8,[39,3],[[4,[38,4],null,null]],[[\"@value\",\"@placeholder\",\"@type\",\"@class\"],[[30,0,[\"twoFactorCode\"]],[28,[37,0],[\"authorization.sign_in_form.2fa_input_placeholder\"],null],\"text\",\"form-control o--form__input\"]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[10,0],[14,0,\"o--formSubmit\"],[12],[1,\"\\n          \"],[8,[39,7],[[24,0,\"qa--login__btn\"],[24,\"data-test-id\",\"login-form-submit-button\"],[24,4,\"submit\"]],[[\"@size\",\"@additional\",\"@text\",\"@isDisabled\"],[\"large\",\"block\",[28,[37,0],[\"authorization.sign_in\"],null],[30,0,[\"isLoginDisabled\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,2],[14,0,\"u--text--center u--m__b__lg u--m__t\"],[12],[1,\"\\n        \"],[1,[52,[30,1],[28,[37,0],[\"authorization.new_to_later_sso_long\"],[[\"ssoAppName\"],[[30,2]]]],[28,[37,0],[\"authorization.new_to_later\"],null]]],[1,\"\\n        \"],[8,[39,8],[[24,0,\"u--p__l__xs\"]],[[\"@route\"],[\"signup\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,9],[[28,[37,0],[\"authorization.create_an_account\"],null]],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[1,\"      \"],[10,0],[14,0,\"u--row u--p__t__lg\"],[12],[1,\"\\n        \"],[8,[39,8],[[24,0,\"u--text--light u--text--underline u--text--sm u--block u--block u--col__6\"]],[[\"@route\"],[\"reset_password\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,0],[\"authorization.sign_in_form.forgot_password\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[11,3],[24,0,\"u--text--light u--text--underline u--text--sm u--block u--col__6\"],[4,[38,1],[\"click\",[28,[37,10],[\"showIgHelp\",[30,0]],null]],null],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"authorization.sign_in_form.sign_in_ig\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"showIgHelp\"]],[[[1,\"          \"],[10,0],[14,0,\"u--col__12 u--fadeIn u--clearfix\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--p__t__xs u--m__b u--text--sm\"],[12],[1,[28,[35,0],[\"authorization.sign_in_form.sign_in_ig_answer\"],null]],[13],[1,\"\\n            \"],[8,[39,8],[[24,0,\"u--text--light u--text--underline u--text--sm u--block u--m__t__xs\"]],[[\"@route\"],[\"forgot_email\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,0],[\"authorization.forgot_email\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[1,\"    \"],[10,0],[14,0,\"tSU--card tSU--card--featured\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"tSU--card__title--featured\"],[12],[1,[28,[35,9],[[28,[37,0],[\"authorization.sign_in_banner.title\"],null]],null]],[13],[1,\"\\n\"],[1,\"\\n\"],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"tSU--container u--hide\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tSU--card\"],[12],[1,\"\\n    \"],[10,\"h1\"],[14,0,\"tSU--card__title\"],[12],[1,[28,[35,0],[\"authorization.get_started.title\"],null]],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--md u--m__b__lg\"],[12],[1,[28,[35,0],[\"authorization.get_started.sub_title\"],null]],[13],[1,\"\\n    \"],[8,[39,7],[[24,0,\"u--m__b u--m__t__lg\"]],[[\"@size\",\"@additional\",\"@text\"],[\"large\",\"block\",[28,[37,0],[\"authorization.get_started.calendar\"],null]]],null],[1,\"\\n    \"],[8,[39,7],null,[[\"@size\",\"@type\",\"@additional\",\"@text\"],[\"large\",\"outline\",\"block\",[28,[37,0],[\"authorization.get_started.rewards\"],null]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@isSsoLogin\",\"@ssoAppName\"],false,[\"t\",\"on\",\"perform\",\"input\",\"autofocus\",\"shared/credentials/password-input\",\"if\",\"shared/ui/button\",\"link-to\",\"html-safe\",\"toggle-action\"]]",
    "moduleName": "auth/components/login-form.hbs",
    "isStrictMode": false
  });

  let LoginForm = (_class = (_clearPassword = /*#__PURE__*/new WeakSet(), class LoginForm extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _clearPassword);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "showIgHelp", _descriptor2, this);

      _initializerDefineProperty(this, "twoFactorCode", _descriptor3, this);

      _initializerDefineProperty(this, "password", _descriptor4, this);
    }

    get isLoginDisabled() {
      return this.args.authenticate.lastSuccessful || (0, _emberConcurrencyTs.taskFor)(this.login).isRunning;
    }

    get twoFactorEnabled() {
      return this.auth.twoFactorEnabled;
    }

    *login(identification, password, otp_attempt, event) {
      event.preventDefault();
      yield this.auth.login(identification, password, otp_attempt, _classPrivateMethodGet(this, _clearPassword, _clearPassword2).bind(this));
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showIgHelp", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "twoFactorCode", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "password", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "login", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "login"), _class.prototype)), _class);
  _exports.default = LoginForm;

  function _clearPassword2() {
    this.password = '';
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LoginForm);
});